// extracted by mini-css-extract-plugin
export default {"Background":"Modal_Background__RtOkE","Background--open":"Modal_Background--open__BtrVo","Modal":"Modal_Modal__PEs88","Modal--open":"Modal_Modal--open__NnUz+"};